var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarOrderManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82 7.5H10L11 2.5H0.999998C0.926869 2.50027 0.854689 2.51657 0.788546 2.54777C0.722404 2.57896 0.663909 2.62429 0.617187 2.68055C0.570464 2.7368 0.536651 2.80263 0.518131 2.87337C0.499611 2.94412 0.496835 3.01806 0.509998 3.09L1.33 7.09C1.34913 7.20565 1.40908 7.31062 1.49899 7.38584C1.58889 7.46107 1.70278 7.50157 1.82 7.5ZM11 2.5L11.42 0.9C11.4431 0.787064 11.5044 0.68556 11.5937 0.612669C11.683 0.539778 11.7947 0.499976 11.91 0.5H13.5M10 7.5L9.58 9.6C9.55695 9.71294 9.49558 9.81444 9.40629 9.88733C9.317 9.96022 9.20527 10 9.09 10H3",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13.5C3.77614 13.5 4 13.2761 4 13C4 12.7239 3.77614 12.5 3.5 12.5C3.22386 12.5 3 12.7239 3 13C3 13.2761 3.22386 13.5 3.5 13.5ZM8.5 13.5C8.77614 13.5 9 13.2761 9 13C9 12.7239 8.77614 12.5 8.5 12.5C8.22386 12.5 8 12.7239 8 13C8 13.2761 8.22386 13.5 8.5 13.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarOrderManagement);
export default __webpack_public_path__ + "static/media/sidebar-order-management.aaa4b29491230dcba3cce9028d378e9c.svg";
export { ForwardRef as ReactComponent };